import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly REFRESH_URL = `${environment.auth_url}/excluded/refresh/token`;
  private readonly AUTH_URL = `${environment.auth_url}/auth/login`;
  private readonly LOGOUT_URL = `${environment.auth_url}/auth/logout`;

  constructor(private http: HttpClient, private router: Router) { }

  login(email: string, pass: string): Observable<any> {
    const payload = {
      principal: email,
      credentials: { password: pass, application: "IDV_B2C_PLATFORM" }
    };

    return this.http.post(this.AUTH_URL, payload).pipe(
      tap((response: any) => {
        const accessToken = response.token || response.data?.token || response.accessToken;
        const refreshToken = response.refreshToken || response.data?.refreshToken;

        if (accessToken) this.saveToken(accessToken);
        if (refreshToken) this.saveRefreshToken(refreshToken);
      })
    );
  }

  refreshToken(): Observable<any> {
    const refreshToken = this.getRefreshToken();
    // Ajusta el payload según tu backend (JSON o string)
    return this.http.post(this.REFRESH_URL, { refreshToken }).pipe(
      tap((response: any) => {
        const newAccessToken = response.token || response.data?.token || response.accessToken;
        if (newAccessToken) {
          this.saveToken(newAccessToken);
        }
      })
    );
  }

  logout(): void {
    const token = this.getToken();
    
    this.clearSessionAndRedirect();
    
    if (token) {
      this.http.post(this.LOGOUT_URL, {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).subscribe({
        next: () => console.log('Token blacklisted successfully'),
        error: (err) => console.error('Error blacklisting token:', err)
      });
    }
  }

  private clearSessionAndRedirect(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    this.router.navigate(['/auth/login']);
  }

  saveToken(token: string) { localStorage.setItem('token', token); }
  getToken(): string | null { return localStorage.getItem('token'); }

  saveRefreshToken(token: string) { localStorage.setItem('refreshToken', token); }
  getRefreshToken(): string | null { return localStorage.getItem('refreshToken'); }

  isLoggedIn(): boolean { return !!this.getToken(); }
}